import React from 'react';
import { X, Check, Zap, Brain, Target, AlertTriangle, MessageSquare } from 'lucide-react';
export function SalesContent() {
  return <div className="bg-slate-950 text-slate-200" data-id="element-144">
      {/* Problem Section */}
      <section className="py-20 px-4 bg-slate-900" data-id="element-145">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-147">
            No es que "no tengas suerte". <br data-id="element-148" />
            <span className="text-[#FF6B35]" data-id="element-149">
              El problema es que nadie te enseñó el juego.
            </span>
          </h2>

          <div className="space-y-4 bg-slate-950 p-8 rounded-xl border border-slate-800" data-id="element-150">
            <p className="font-bold text-lg text-white mb-4" data-id="element-151">
              Si esto te pasa, este libro es para ti:
            </p>

            {['Te quedas sin saber qué decir cuando alguien te gusta', "Sientes que otros 'naturalmente' conectan y tú no", 'Te rechazan y lo tomas personal', 'Piensas demasiado cada mensaje que envías', "Te dicen 'eres buena persona'… pero no pasa de ahí"].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-152">
                <X className="w-6 h-6 text-red-500 shrink-0" data-id="element-153" />
                <p data-id="element-154">{item}</p>
              </div>)}

            <p className="pt-4 text-slate-400 italic border-t border-slate-800 mt-6" data-id="element-155">
              No te falta valor. Te falta entender el juego emocional que nadie
              explicó.
            </p>
          </div>
        </div>
      </section>

      {/* Truth Section */}
      <section className="py-20 px-4" data-id="element-156">
        <div className="max-w-3xl mx-auto text-center" data-id="element-157">
          <div className="inline-flex items-center gap-2 text-[#E63946] font-bold mb-6 animate-pulse" data-id="element-158">
            <AlertTriangle className="w-6 h-6" data-id="element-159" />
            LA VERDAD QUE NADIE DICE
          </div>

          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-160">
            La atracción NO empieza con:
          </h3>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-161">
            <span className="px-4 py-2 bg-slate-800 rounded-full text-slate-400 line-through decoration-red-500 decoration-2" data-id="element-162">
              Dinero
            </span>
            <span className="px-4 py-2 bg-slate-800 rounded-full text-slate-400 line-through decoration-red-500 decoration-2" data-id="element-163">
              Frases perfectas
            </span>
            <span className="px-4 py-2 bg-slate-800 rounded-full text-slate-400 line-through decoration-red-500 decoration-2" data-id="element-164">
              Apariencia de modelo
            </span>
          </div>

          <h3 className="text-2xl font-bold text-[#FF6B35] mb-8" data-id="element-165">
            Empieza con:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left" data-id="element-166">
            {['Energía emocional', 'Seguridad interna', 'Tensión bien manejada', 'Comunicación que genera curiosidad', 'Mentalidad que no necesita aprobación'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-167">
                <Check className="w-5 h-5 text-green-500" data-id="element-168" />
                <span className="font-medium text-white" data-id="element-169">{item}</span>
              </div>)}
          </div>

          <p className="mt-12 text-xl font-bold text-white" data-id="element-170">
            Eso es exactamente lo que construye{' '}
            <span className="text-[#FF6B35]" data-id="element-171">ATRACCIÓN REAL™</span>.
          </p>
        </div>
      </section>

      {/* What is Section */}
      <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-174">
            <div className="flex-1" data-id="element-175">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-176">
                ¿QUÉ ES "ATRACCIÓN REAL™"?
              </h2>
              <p className="text-lg text-slate-300 mb-6 leading-relaxed" data-id="element-177">
                Un sistema práctico para que dejes de intentar gustar y empieces
                a provocar interés de forma natural.
              </p>
              <p className="text-slate-400 mb-6" data-id="element-178">
                No es teoría psicológica aburrida. No es manipulación barata. No
                son "trucos de pick up".
              </p>
              <div className="flex items-center gap-4 text-white font-bold text-lg" data-id="element-179">
                <Brain className="w-6 h-6 text-[#FF6B35]" data-id="element-180" />
                Entrenamiento mental
                <span className="text-slate-500" data-id="element-181">+</span>
                <MessageSquare className="w-6 h-6 text-[#FF6B35]" data-id="element-182" />
                Comunicación emocional
              </div>
            </div>
            <div className="flex-1 bg-slate-950 p-8 rounded-2xl border border-slate-800 shadow-xl" data-id="element-183">
              <h3 className="font-bold text-white mb-6 flex items-center gap-2" data-id="element-184">
                <Target className="w-5 h-5 text-[#FF6B35]" data-id="element-185" />
                DENTRO DEL LIBRO APRENDERÁS A:
              </h3>
              <ul className="space-y-4" data-id="element-186">
                {['Proyectar seguridad aunque por dentro tengas nervios', 'Hablar sin parecer necesitado', 'Generar conexión sin forzar conversaciones', 'Manejar el rechazo sin que te destruya', 'Crear tensión atractiva sin decir cosas raras', 'Entender por qué alguien pierde interés', 'Leer señales emocionales reales'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm md:text-base text-slate-300" data-id="element-187">
                    <Check className="w-5 h-5 text-[#FF6B35] shrink-0 mt-0.5" data-id="element-188" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="py-20 px-4" data-id="element-189">
        <div className="max-w-3xl mx-auto text-center" data-id="element-190">
          <h2 className="text-3xl font-bold text-white mb-12" data-id="element-191">
            LO MÁS IMPORTANTE QUE CAMBIA
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-192">
            <div className="bg-red-900/10 p-6 rounded-xl border border-red-900/30" data-id="element-193">
              <h3 className="text-red-400 font-bold mb-4" data-id="element-194">ANTES</h3>
              <ul className="space-y-3 text-left text-slate-400 text-sm" data-id="element-195">
                <li className="flex gap-2" data-id="element-196">
                  <X className="w-4 h-4 text-red-500" data-id="element-197" /> Mendigas atención
                </li>
                <li className="flex gap-2" data-id="element-198">
                  <X className="w-4 h-4 text-red-500" data-id="element-199" /> Persigues validación
                </li>
                <li className="flex gap-2" data-id="element-200">
                  <X className="w-4 h-4 text-red-500" data-id="element-201" /> Te obsesionas por un
                  mensaje
                </li>
                <li className="flex gap-2" data-id="element-202">
                  <X className="w-4 h-4 text-red-500" data-id="element-203" /> Entras en pánico por el
                  rechazo
                </li>
              </ul>
            </div>

            <div className="bg-green-900/10 p-6 rounded-xl border border-green-900/30" data-id="element-204">
              <h3 className="text-green-400 font-bold mb-4" data-id="element-205">DESPUÉS</h3>
              <ul className="space-y-3 text-left text-slate-300 text-sm" data-id="element-206">
                <li className="flex gap-2" data-id="element-207">
                  <Check className="w-4 h-4 text-green-500" data-id="element-208" /> Conversaciones
                  fluyen más
                </li>
                <li className="flex gap-2" data-id="element-209">
                  <Check className="w-4 h-4 text-green-500" data-id="element-210" /> Te sientes
                  tranquilo al hablar
                </li>
                <li className="flex gap-2" data-id="element-211">
                  <Check className="w-4 h-4 text-green-500" data-id="element-212" /> El rechazo ya no
                  te tumba
                </li>
                <li className="flex gap-2" data-id="element-213">
                  <Check className="w-4 h-4 text-green-500" data-id="element-214" /> Proyectas
                  presencia real
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-8 rounded-xl border border-slate-700" data-id="element-215">
            <Zap className="w-10 h-10 text-yellow-400 mx-auto mb-4" data-id="element-216" />
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-217">
              Empiezas a moverte desde{' '}
              <span className="text-[#FF6B35]" data-id="element-218">seguridad</span>, no desde miedo.
            </p>
            <p className="mt-2 text-slate-400" data-id="element-219">Y eso cambia TODO.</p>
          </div>
        </div>
      </section>
    </div>;
}